module.exports = __webpack_public_path__ + "static/media/autozone.1c1f7fb4.jpg";